export const en = {
  meta: {
    pageTitle: "{{page}} - Calendar App",
    appName: "Calendar-App",
  },
  nav: {
    appTitle: "Calendar App",
    home: "Home",
    records: "Records",
    dashboard: "Dashboard",
    admin: "Admin",
    adminWithPage: "Admin-{{page}}",
    users: "Users",
    cron: "Cron",
    trash: "Trash",
    settings: "Settings",
    logout: "Logout",
    language: "Language",
    record: "Record",
    calendar: "Calendar",
    place: "Place",
    resetPassword: "Reset Password",
  },
  common: {
    save: "Save",
    saveChanges: "Save changes",
    cancel: "Cancel",
    close: "Close",
    confirm: "Confirm",
    delete: "Delete",
    add: "Add",
    edit: "Edit",
    view: "View",
    search: "Search",
    map: "Map",
    submit: "Submit",
    reset: "Reset",
    run: "Run",
    restore: "Restore",
    loading: "Loading...",
    pleaseSelect: "Please select",
    invalidDate: "Invalid Date",
    notAvailable: "N/A",
    warning: "Warning:",
    showHide: "Show/Hide",
    unableToLoadData: "Unable to load data.",
    pleaseEnterValidField: "Please enter a valid {{field}}!",
    pleaseEnterTheField: "Please enter the [{{field}}]!",
  },
  fields: {
    password: "Password",
    confirmPassword: "Confirm Password",
    confirmPasswordSentence: "Confirm password",
    currentPassword: "Current Password",
    newPassword: "New Password",
    newPasswordSentence: "New password",
    email: "Email",
    emailAddress: "Email address",
    id: "ID",
    username: "Username",
    role: "Role",
    name: "Name",
    title: "Title",
    description: "Description",
    address: "Address",
    color: "Color",
    calendar: "Calendar",
    calendars: "Calendars",
    place: "Place",
    record: "Record",
    startDate: "Start Date",
    endDate: "End Date",
    start: "Start",
    end: "End",
    prefix: "Prefix",
    created: "Created",
    lastUpdated: "Last Updated",
    defaultShow: "Default Show",
    calendarName: "Calendar Name",
    placeName: "Place Name",
    recordType: "Record Type",
    action: "Action",
    selectCalendars: "Select Calendars",
  },
  login: {
    title: "Login",
    login: "Login",
    passwordEmpty: "Please enter Password.",
    passwordIncorrect:
      "Wrong password. Try again or click Forgot password to reset it.",
    emailInvalid: "Please enter a valid email.",
    forgotPassword: "Forgot Password?",
    forgotPasswordTitle: "Forgot Password",
    submit: "Login",
    resetPassword: "Reset Password",
    resetEmailSent: "Password reset email sent successfully.",
    resetEmailFailed: "Failed to send password reset email. Please try again.",
  },
  reset: {
    title: "Reset Password",
    passwordEmpty: "Please enter Password.",
    unableToReset: "Unable to reset password!",
    userNotFound: "Unable to find user!",
    linkExpired: "Reset link has expired! Please request a new one!",
    passwordsDoNotMatch: "Passwords do not match!",
    invalidResetLink: "Invalid reset link!",
    passwordResetSuccessful: "Password reset successful!",
    submit: "Submit",
    linkExpiredTitle: "Link Expired",
  },
  record: {
    createOneSuccess: "Record Id({{id}}) successfully created!",
    createManySuccess: "Records({{num}}) successfully created!",
    createFailed: "Unable to create new Record!",
    updateFailed: "Unable to Update({{id}}) Record!",
    updateMultiFailed: "Unable to Update({{ids}}) Record!",
    updateSuccess: "Record({{id}}) successfully updated!",
    updateMultiSuccess: "Record({{ids}}) successfully updated!",
    deleteFailed: "Unable to delete Record({{id}})!",
    deleteMultiFailed: "Unable to delete({{ids}}) Record!",
    deleteSuccess: "Record({{id}}) deleted!",
    deleteMultiSuccess: "Record({{ids}}) deleted!",
    failedToLoad: "Unable to get Record data!",
    failedToFindId: "Unable to find Record id!",
    idInvalid: "Record id is not valid!",
    editMany: "Edit Records ({{count}})",
    deleteMany: "Delete Records ({{count}})",
  },
  calendar: {
    createSuccess: "Calendar ({{name}}) successfully created!",
    createFailed: "Unable to create new Calendar!",
    updateFailed: "Unable to Update Calendar({{name}}) !",
    updateSuccess: "Calendar({{name}}) successfully updated!",
    deleteFailed: "Unable to delete Calendar({{name}})!",
    deleteSuccess: "Calendar({{name}}) deleted!",
    failedToLoad: "Unable to get Calendar data!",
    nameInvalid: "Calendar name({{name}}) is invalid!",
    nameExists: "Calendar name({{name}}) already exists!",
    colorInvalid: "Calendar color is not valid!",
    add: "Add Calendar",
    edit: "Edit Calendar",
    menu: "Calendars",
    listTitle: "Calendars",
    noCalendars: "No calendars yet!",
    selectCalendars: "Select Calendars",
    name: "Name",
    namePlaceholder: "Calendar Name",
    color: "Color",
    defaultShow: "Default Show",
  },
  place: {
    createSuccess: "Place ({{name}}) successfully created!",
    createFailed: "Unable to create new Place!",
    updateFailed: "Unable to Update Place({{name}}) !",
    updateSuccess: "Place({{name}}) successfully updated!",
    deleteFailed: "Unable to delete Place({{name}})!",
    deleteSuccess: "Place({{name}}) deleted!",
    failedToLoad: "Unable to get Place data!",
    nameInvalid: "Place name({{name}}) is invalid!",
    nameExists: "Place name({{name}}) already exists!",
    addressEmpty: "Place address is empty!",
    add: "Add Place",
    edit: "Edit Place",
    listTitle: "Places",
  },
  cron: {
    createSuccess: "Cron Job ({{name}}) successfully created!",
    createFailed: "Unable to create new Cron Job!",
    updateFailed: "Unable to Cron Job({{id}}) !",
    updateSuccess: "Cron Job({{id}}) successfully updated!",
    deleteFailed: "Unable to delete Cron Job({{id}})!",
    deleteSuccess: "Cron Job({{id}}) deleted!",
    failedToLoad: "Unable to get Place data!",
    invalid: "Cron Value is invalid!",
    exists: "Cron Job({{name}}) already exists!",
    runSuccess: "Cron Job({{name}}) executed successfully!",
    runFailed: "Cron Job({{name}}) execution failed!",
    addCronJob: "Add Cron Job",
    editCronJob: "Edit Cron Job",
  },
  calendarUi: {
    failedToFindEvent: "Unable to find Event({{id}})!",
    failedToGetApi: "Unable to find [calendarApi]!",
  },
  event: {
    add: "Add Event",
    edit: "Edit Event",
    deleteTitle: "Delete Event",
    deleteConfirm: "Are you sure to delete this Event?",
    unableToGet: "Unable to get event data!",
    copied: "Event({{id}}) copied!",
    copy: "Copy Event",
    endBeforeStart: "End Date must be greater than Start Date!",
    endDateInvalid: "Please enter a valid End Date!",
    endDateRequired: "Please enter the End Date!",
    mapTitle: "Map - {{name}}",
  },
  grid: {
    emptySelection: "Please select a record!",
    emptyData: "No records found!",
    doesNotIncludeRecord: "Grid does not include Record({{id}})!",
    doesNotIncludeMultiRecord: "Grid does not include Record({{ids}})!",
    failedToFindRowById: "Unable to find Record by Id({{id}})!",
    pleaseSelectRecords: "Please select at least 1 record(s)!",
    failedToRestore: "Failed to Restore ({{type}}) record(s)!",
    failedToDelete: "Failed to Delete ({{type}}) record(s)!",
    restored: "Restored {{count}} of ({{type}}) record(s)!",
    deleted: "Deleted {{count}} of ({{type}}) record(s)!",
    copiedToClipboard: "Copied to clipboard!",
    paginationNext: "Next",
    paginationPrevious: "Prev",   
  },
  settings: {
    title: "Settings",
    password: "Password",
    passwordEmpty: "Please enter Password.",
    passwordIncorrect: "Old password incorrect!",
    confirmPasswordNotMatch: "Password does not match!",
    updateSuccess: "Password Updated!",
    userDetailNotFound: "Unable to find User Detail!",
    keepCurrentPassword: "Leave blank to keep the current password",
  },
  user: {
    failedToLoad: "Unable to get User data!",
    usernameEmpty: "Please enter a username.",
    passwordEmpty: "Please enter a password.",
    passwordMismatch: "Passwords do not match.",
    createSuccess: "User created.",
    createFailed: "Unable to create user.",
    updateSuccess: "User updated.",
    updateFailed: "Unable to update user.",
    deleteSuccess: "User deleted.",
    deleteFailed: "Unable to delete user.",
    cannotDeleteSelf: "You cannot delete the signed-in user.",
    selectOne: "Please select a user.",
    addUser: "Add User",
    editUser: "Edit User",
    deleteTitle: "Delete User",
    deleteWarning:
      "This permanently deletes the user. A user who still has places or records cannot be deleted.",
  },
  dashboard: {
    title: "Dashboard",
    fetchFailed: "Failed to fetch dashboard data.",
    nextEvents: "Next Events",
    prevEvents: "Prev Events",
    upcomingEvents: "Upcoming Events",
    nextHoliday: "Next Holiday",
    noHoliday: "No Holiday...",
    monthEvents: "No of Month Events",
    monthlySummary: "{{year}} Monthly Summary",
    eventDistribution: "{{year}} Event Distribution",
    totalEventDistribution: "Total Event Distribution",
    events: "Events",
  },
};

type Widen<T> = T extends string ? string : { [K in keyof T]: Widen<T[K]> };

export type Messages = Widen<typeof en>;
